// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2aQpP","vLegacy":"SelectSecondary_vLegacy__X34Fw","error":"SelectSecondary_error__1v6Qj","disabled":"SelectSecondary_disabled__in8KS"};